/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Emergency_DescInputs */

const en_home_benefit_emergency_desc = /** @type {(inputs: Home_Benefit_Emergency_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical coordination, hospital referrals, and evacuation support — anywhere in the world.`)
};

const fr_home_benefit_emergency_desc = /** @type {(inputs: Home_Benefit_Emergency_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordination médicale, références hospitalières et soutien à l'évacuation — partout dans le monde.`)
};

/**
* | output |
* | --- |
* | "Medical coordination, hospital referrals, and evacuation support — anywhere in the world." |
*
* @param {Home_Benefit_Emergency_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_emergency_desc = /** @type {((inputs?: Home_Benefit_Emergency_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Emergency_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_emergency_desc(inputs)
	return fr_home_benefit_emergency_desc(inputs)
});